<template>
  <div class="containerSearch">
    <div>
      <a-input placeholder="设备名称" v-model="searchModel.name" />
    </div>
    <div>
      <a-input placeholder="设备编号" v-model="searchModel.equipmentNumber" />
    </div>
    <div>
      <a-input placeholder="内部编号" v-model="searchModel.interiorCode" />
    </div>
    <div>
      <a-select
        v-model="searchModel.equipmentStatus"
        :allowClear="true"
        placeholder="设备状态"
        style="width: 100%">
        <a-select-option v-for="(item, index) in equipmentStatusList" :key="index" :value="item.code">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-input placeholder="规格型号" v-model="searchModel.specification" />
    </div>
    <div>
      <a-input placeholder="设备品牌" v-model="searchModel.brand" />
    </div>
    <div>
      <a-select
        :allowClear="true"
        v-model="searchModel.relevantdeptid"
        showSearch
        :filterOption="filterOption"
        optionFilterProp="label"
        placeholder="归口部门"
        @change="changeRelevantdeptid"
        style="width: 100%"
      >
        <a-select-option v-for="(item, index) in focalDepartmentsList" :value="item.deptId" :label="item.departmentname" :key="index">
          {{ item.departmentname }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-select
        :allowClear="true"
        v-model="searchModel.relevantdeptUserId"
        showSearch
        :filterOption="filterOption"
        optionFilterProp="label"
        placeholder="归口部门负责人"
        @change="changeRelevantdeptUserId"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in centralizedDepartmentCenter"
          :key="index"
          :value="item.id">
          {{ item.lastname }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-tree-select
        v-model="searchModel.usedeptid"
        style="width: 100%"
        placeholder="使用部门"
        allow-clear
        show-search
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :treeData="useDepartmentsList"
        treeNodeFilterProp="title"
        @change="changeUsedeptid"
        treeNodeLabelProp="label"
        :replaceFields="{
          title: 'url',
          key: 'key',
          value: 'key'
        }"
      ></a-tree-select>
    </div>
    <div>
      <a-input placeholder="使用人员" v-model="searchModel.principalName" />
    </div>
    <div>
      <a-input placeholder="资产卡片号" v-model="searchModel.assetNumber" />
    </div>
    <div>
      <a-range-picker
        :placeholder="['首次投用开始日期', '首次投用结束日期']"
        :showToday="false"
        format="YYYY-MM-DD"
        v-model="searchModel.entryDateList"
        style="width: 100%"
        class="inputBetween"
        @change="$forceUpdate()"
      />
    </div>
    <div>
      <a-range-picker
        :placeholder="['报废开始日期', '报废结束日期']"
        :showToday="false"
        format="YYYY-MM-DD"
        v-model="searchModel.retirementDateList"
        style="width: 100%"
        class="inputBetween"
        @change="$forceUpdate()"
      />
    </div>
    <div v-if="!delEquipmentType">
      <a-tree-select
        v-model="searchModel.equipmentType"
        style="width: 100%"
        placeholder="设备类型"
        show-search
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :treeData="deviceTypeList"
        treeNodeFilterProp="title"
        :replaceFields="{
          title: 'name',
          key: 'key',
          value: 'code'
        }"
      ></a-tree-select>
    </div>
    <div>
      <a-select
        :allowClear="true"
        v-model="searchModel.isYlrqPeculiarity"
        showSearch
        :filterOption="filterOption"
        optionFilterProp="label"
        placeholder="是否压力容器"
        @change="changeRelevantdeptUserId"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in yesOrNoSignList"
          :key="index"
          :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-select
        :allowClear="true"
        v-model="searchModel.isHbPeculiarity"
        showSearch
        :filterOption="filterOption"
        optionFilterProp="label"
        placeholder="是否环保设备"
        @change="changeRelevantdeptUserId"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in yesOrNoSignList"
          :key="index"
          :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-select
        :allowClear="true"
        v-model="searchModel.isTzsbPeculiarity"
        showSearch
        :filterOption="filterOption"
        optionFilterProp="label"
        placeholder="是否特种设备"
        @change="changeRelevantdeptUserId"
        style="width: 100%"
      >
        <a-select-option
          v-for="(item, index) in yesOrNoSignList"
          :key="index"
          :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div>
      <a-input placeholder="备注" v-model="searchModel.remark" />
    </div>
    <!--    <div class="searchButton">-->
    <!--      <a-button type="primary" @click="search(false)">-->
    <!--        查询-->
    <!--      </a-button>-->
    <!--      <a-button @click="reset" style="margin-left: 12px;">-->
    <!--        重置-->
    <!--      </a-button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { getDictList } from '@/api/equipmentLedger'
import { getfocalDepartmentsList, getTreeByRoleUsedeptList } from '@/api/assetLedger'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { getUserList } from '@/api/organizationalStructure'
import { getDeptHasBeenConfigured } from '@/api/centralizedDeptManagement'
import { getDeviceTypeTree } from '@/api/deviceType'

export default {
  name: 'TopSearch',
  props: {
    delEquipmentType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchModel: {},
      // 设备状态
      equipmentStatusList: [],
      // 归口部门
      focalDepartmentsList: [],
      // 归口部门负责人
      centralizedDepartmentCenter: [],
      // 使用部门
      useDepartmentsList: [],
      // 设备类型列表
      deviceTypeList: [],
      // 是否列表
      yesOrNoSignList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      companyId: null,
      // 原始设备类型，用于判断气体设备搜索时，设备类型是否改变
      equipmentType: null
    }
  },
  computed: {
    ...mapGetters(['centralizedManagementCompanyId'])
  },
  created () {
    this.getEquipmentStatusList()
    this.companyId = this.centralizedManagementCompanyId.id === '杭氧' ? '' : this.centralizedManagementCompanyId.id
    this.getUseDepartmentsList()
    this.getFocalDepartmentsList()
    this.getDeviceTypeList()
  },
  watch: {
    centralizedManagementCompanyId (newValue) {
      this.searchModel.relevantdeptid = undefined
      this.searchModel.relevantdeptUserId = undefined
      this.centralizedDepartmentCenter = []
      this.searchModel.usedeptid = undefined
      this.searchModel.usedeptidKey = undefined
      this.searchModel.principalName = ''
      if (newValue.id !== '') {
        if (newValue.id === '空' || newValue.id === '杭氧') {
          if (newValue.id === '杭氧') {
            this.companyId = null
          }
          this.useDepartmentsList = []
        } else {
          this.companyId = newValue.id
        }
      } else {
        this.companyId = null
      }
      if (newValue.id !== '空') {
        this.getUseDepartmentsList()
        this.getFocalDepartmentsList()
      }
    }
  },
  methods: {
    ...mapActions(['handleEquipmentType']),
    // 获取设备类型
    getDeviceTypeList () {
      const data = {
        code: '1800000000'
      }
      getDeviceTypeTree(data).then(res => {
        if (res.status === 0) {
          // this.deviceTypeList = [res.data.find(item => item.name === '气体板块设备')]
          this.deviceTypeList = res.data
          if (!this.delEquipmentType) {
            const data = res.data[0]
            this.searchModel.equipmentType = data.code
            this.handleEquipmentType({
              equipmentType: data.code,
              equipmentData: data,
              numberOfUpdates: this.numberOfUpdates++
            })
          }
        }
      })
    },
    // 重置children数组
    resetTheChildrenArray (children, pName) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (pName) {
            item.label = pName + '/' + item.url
          } else {
            item.label = item.url
          }
          if (item.children && item.children.length) {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = self.resetTheChildrenArray(item.children, item.label)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 设置查询条件
    setSearchModel (searchModel) {
      this.searchModel = JSON.parse(JSON.stringify(searchModel))
      if (this.searchModel.retirementDateList) {
        this.searchModel.retirementDateList = [moment(this.searchModel.retirementDate, 'YYYY-MM-DD'), moment(this.searchModel.retirementDateEnd, 'YYYY-MM-DD')]
      }
      if (this.searchModel.entryDateList) {
        this.searchModel.entryDateList = [moment(this.searchModel.entryDate, 'YYYY-MM-DD'), moment(this.searchModel.entryDateEnd, 'YYYY-MM-DD')]
      }
      if (this.searchModel.relevantdeptUserId) {
        this.getCentralizedDepartmentCenterList(this.searchModel.relevantdeptid)
      }
      if (this.searchModel.usedeptidKey) {
        this.searchModel.usedeptid = this.searchModel.usedeptidKey
      }
      if (!this.delEquipmentType) {
        this.equipmentType = this.searchModel.equipmentType
      }
    },
    // 获取使用部门
    getUseDepartmentsList () {
      const data = {
        paging: false,
        isAsset: true
      }
      if (this.companyId) {
        data.companyId = this.companyId
      }
      getTreeByRoleUsedeptList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.label = item.url
            item.children = this.resetTheChildrenArray(item.children, item.url)
          })
          this.useDepartmentsList = res.data
        }
      })
    },
    // 获取归口部门负责人
    getCentralizedDepartmentCenterList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.centralizedDepartmentCenter = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取设备状态列表
    getEquipmentStatusList () {
      const data = {
        pCode: 'sb_sbzt'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.equipmentStatusList = res.data
        }
      })
    },
    // 获取归口部门下拉数据
    getFocalDepartmentsList () {
      const data = {
        subcompanyid: this.companyId
      }
      getDeptHasBeenConfigured(data).then(res => {
        if (res.status === 0) {
          this.focalDepartmentsList = res.data
        }
      })
    },
    // 改变归口部门
    changeRelevantdeptid (value) {
      this.searchModel.relevantdeptUserId = undefined
      if (value) {
        this.getCentralizedDepartmentCenterList(value)
      } else {
        this.centralizedDepartmentCenter = []
      }
    },
    // 改变归口部门负责人
    changeRelevantdeptUserId (value) {
      this.$forceUpdate()
    },
    // 改变使用部门
    changeUsedeptid (value) {
      if (!value) {
        delete this.searchModel.usedeptidKey
      }
      this.$forceUpdate()
    },
    findNode (treeList, value) {
      for (let i = 0; i < treeList.length; i++) {
        const node = treeList[i]
        if (node.code === value) {
          return node
        }
        if (node.children && node.children.length > 0) {
          const result = this.findNode(node.children, value)
          if (result) {
            return result
          }
        }
      }
    },
    // 查询
    search (notSearch) {
      if (!this.delEquipmentType) {
        if (this.searchModel.equipmentType) {
          // 根据value在deviceTypeList树结构中查找对应的节点
          const node = this.findNode(this.deviceTypeList, this.searchModel.equipmentType)
          console.log(node)
          this.handleEquipmentType({
            equipmentType: node.code,
            equipmentData: node,
            numberOfUpdates: this.numberOfUpdates++
          })
        }
        if (!this.searchModel.hasOwnProperty('equipmentType')) {
          this.searchModel.equipmentType = '1800000000'
        }
      }
      const model = JSON.parse(JSON.stringify(this.searchModel))
      // 首次投用开始日期/结束
      if (model.entryDateList && model.entryDateList.length > 0) {
        model.entryDate = moment(model.entryDateList[0]).format('YYYY-MM-DD 00:00:00')
        model.entryDateEnd = moment(model.entryDateList[1]).format('YYYY-MM-DD 00:00:00')
      } else {
        delete model.entryDate
        delete model.entryDateEnd
      }
      // 报废开始日期/结束
      if (model.retirementDateList && model.retirementDateList.length > 0) {
        model.retirementDate = moment(model.retirementDateList[0]).format('YYYY-MM-DD 00:00:00')
        model.retirementDateEnd = moment(model.retirementDateList[1]).format('YYYY-MM-DD 00:00:00')
      } else {
        delete model.retirementDate
        delete model.retirementDateEnd
      }
      // 使用部门
      if (model.usedeptid) {
        model.usedeptidKey = model.usedeptid
        model.usedeptid = Number(model.usedeptid.slice(0, model.usedeptid.indexOf('_')))
      }
      for (var item in model) {
        if (!model[item] || model[item].length === 0) {
          if (item === 'isYlrqPeculiarity' || item === 'isHbPeculiarity' || item === 'isTzsbPeculiarity') {
            if (model[item] !== 0 && model[item] !== 1) {
              delete model[item]
            }
          } else {
            delete model[item]
          }
        }
      }
      if (!this.delEquipmentType) {
        if (this.equipmentType !== this.searchModel.equipmentType) {
          this.$emit('search', model, notSearch, [model.equipmentType])
        } else {
          this.$emit('search', model, notSearch)
        }
      } else {
        this.$emit('search', model, notSearch)
      }
    },
    // 重置
    reset () {
      // this.searchModel = {
      //   delpid: false
      // }
      if (!this.delEquipmentType) {
        const data = this.deviceTypeList[0]
        this.searchModel.equipmentType = data.code
        this.handleEquipmentType({
          equipmentType: data.code,
          equipmentData: data,
          numberOfUpdates: this.numberOfUpdates++
        })
        this.searchModel = {
          delpid: false,
          equipmentType: this.searchModel.equipmentType
        }
      } else {
        this.searchModel = {
          delpid: false
        }
      }
      this.$emit('reset', this.searchModel)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
.containerSearch {
  display: inline-grid;
  width: 100%;
  grid-template-columns: repeat(4, calc((100% - 30px) / 4));
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  .column3_5 {
    grid-column-start: 3;
    grid-column-end: 5;
  }
  .column2_5 {
    grid-column-start: 2;
    grid-column-end: 5;
  }
  .searchButton {
    grid-column-start: 4;
    grid-column-end: 5;
    justify-self: end;
  }
  .inputBetween {
    /deep/.ant-calendar-picker-input {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
